import { render, staticRenderFns } from "./PrintView.vue?vue&type=template&id=6cb033c5&scoped=true&"
import script from "./PrintView.vue?vue&type=script&lang=js&"
export * from "./PrintView.vue?vue&type=script&lang=js&"
import style0 from "./PrintView.vue?vue&type=style&index=0&id=6cb033c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb033c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSheet,VSimpleTable})
